import React from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import UFOCustomData from '@atlaskit/react-ufo/custom-data';

export const getIsInJiraHoldoutData = (): {
	holdout: string;
} => {
	const featureGateWithinHoldout = 'product-jira-holdout-org_id-observability-gate';

	// This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
	const isInJiraHoldout =
		FeatureGates.initializeCompleted() &&
		!FeatureGates.checkGate(featureGateWithinHoldout, {
			fireGateExposure: false,
		});

	return {
		holdout: isInJiraHoldout ? 'jira-holdout' : '',
	};
};

export const JiraHoldoutCustomData = (): React.JSX.Element | null => {
	return <UFOCustomData data={getIsInJiraHoldoutData()} />;
};
